const rekapTransaksiDummy = [
  {
    id: 1,
    startDate: "09 Sep 2024, 16:51",
    endDate: "09 Sep 2024, 16:55",
    clientName: "Mega Sangsekerta Teknologi",
    clientCode: "MEG934",
    totalTransactions: 1250,
    totalAmount: 1560000000,
    status: "Berhasil"
  },
  {
    id: 2,
    startDate: "04 Sep 2024, 06:16",
    endDate: "06 Sep 2024, 06:16",
    clientName: "AGRO NEOTIC JAYA",
    clientCode: "AGR114",
    totalTransactions: 500,
    totalAmount: 750000000,
    status: "Berhasil"
  },
  {
    id: 3,
    startDate: "26 Jul 2024, 00:08",
    endDate: "26 Jul 2024, 00:12",
    clientName: "Panglima Puji Nusantara",
    clientCode: "PAN131",
    totalTransactions: 300,
    totalAmount: 45000000,
    status: "Berhasil"
  },
  {
    id: 4,
    startDate: "07 Jul 2024, 18:57",
    endDate: "16 Apr 2025, 13:39",
    clientName: "Paman Ryan Indonesia",
    clientCode: "PAM692",
    totalTransactions: 80,
    totalAmount: 12000000,
    status: "Pending"
  },
  {
    id: 5,
    startDate: "07 Jul 2024, 14:21",
    endDate: "07 Jul 2024, 14:25",
    clientName: "Pandu Rima Utami",
    clientCode: "PAN412",
    totalTransactions: 150,
    totalAmount: 22500000,
    status: "Berhasil"
  },
  {
    id: 6,
    startDate: "07 Jul 2024, 11:10",
    endDate: "07 Jul 2024, 11:19",
    clientName: "PT Tolong Transfer Paman Ryan",
    clientCode: "PT_343",
    totalTransactions: 45,
    totalAmount: 6750000,
    status: "Gagal"
  },
  {
    id: 7,
    startDate: "20 Jun 2024, 10:24",
    endDate: "20 Jun 2024, 10:28",
    clientName: "Kreasi Kuantum Indonesia",
    clientCode: "KRE679",
    totalTransactions: 200,
    totalAmount: 30000000,
    status: "Berhasil"
  },
  {
    id: 8,
    startDate: "20 May 2024, 18:42",
    endDate: "20 May 2024, 18:46",
    clientName: "Bursa Akselerasi Indonesia",
    clientCode: "BUR815",
    totalTransactions: 180,
    totalAmount: 27000000,
    status: "Berhasil"
  },
  {
    id: 9,
    startDate: "18 Apr 2024, 10:08",
    endDate: "18 Apr 2024, 10:13",
    clientName: "Sumbermas Arta Abadi",
    clientCode: "SUM739",
    totalTransactions: 350,
    totalAmount: 52500000,
    status: "Berhasil"
  },
  {
    id: 10,
    startDate: "05 Apr 2024, 09:10",
    endDate: "05 Apr 2024, 09:15",
    clientName: "Sazka Sejahtera Jaya",
    clientCode: "SAZ066",
    totalTransactions: 90,
    totalAmount: 13500000,
    status: "Berhasil"
  }
];

export default rekapTransaksiDummy;
